import { atom } from 'recoil';

export const scanResultsAtom = atom({
  key: 'scanResultsAtom', 
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});